
import { TOKEN_BROWSER } from './ServicioConstantes';
import { v4 as uuidv4 } from 'uuid';
import servicioObjetos from './ServicioAsignacionValoresObjetos';

export function setIdentificador(token) {   
    localStorage.setItem(TOKEN_BROWSER, token);
}

export function eliminarIdentificador(){
    localStorage.removeItem(TOKEN_BROWSER);    
}

export function getIdentificador() {
    return new Promise((resolve, reject) => {
        let tokenLocalStorage = localStorage.getItem(TOKEN_BROWSER);        
        if (servicioObjetos.esObjetoVacio(tokenLocalStorage)) {
            let uuid=uuidv4();
            setIdentificador(uuid);
            resolve(uuid);
        } else {
            resolve(tokenLocalStorage);
        }
    });
}

export function obtenerIdentificadorNavegador(){
    return localStorage.getItem(TOKEN_BROWSER);
}